<template>
  <DeleteConfirm
      itemKey="Project"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Projects from '@/services/projects'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Projects
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť projekt "' + Item.title + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť projekt "' + Item.title + '"?'
      },
      deleteData() {
        return Projects
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
